import script from "./StatusesView.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusesView.vue?vue&type=script&setup=true&lang=js"

import "./StatusesView.vue?vue&type=style&index=0&id=fd56a630&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd56a630"]])

export default __exports__